"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.portalWalkthroughSaga = exports.getPortalWalkthrough = exports.getPortalWalkthroughScreens = void 0;
var effects_1 = require("redux-saga/effects");
var typesafe_actions_1 = require("typesafe-actions");
var get_cms_client_1 = __importDefault(require("@portal/common/dist/utils/get-cms-client"));
var even_cms_1 = require("@portal/even-cms");
var configuration_1 = require("../../configuration");
var actions_1 = require("../actions");
function getPortalWalkthroughScreens(_a) {
    var config, client, _b, data, err_1;
    var id = _a.payload.id;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 4, , 6]);
                return [4, (0, effects_1.select)(configuration_1.getApplicationConfiguration)];
            case 1:
                config = _c.sent();
                client = (0, get_cms_client_1.default)(even_cms_1.ItemsPortalWalkthroughScreensApi, config);
                return [4, (0, effects_1.apply)(client, client.readItemsPortalWalkthroughScreens, [
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        ["{\"walkthough\": { \"_eq\": ".concat(id, " }}")],
                    ])];
            case 2:
                _b = (_c.sent()).data.data, data = _b === void 0 ? [] : _b;
                return [4, (0, effects_1.putResolve)(actions_1.cmsWalkthroughScreensRequestAction.success(data))];
            case 3:
                _c.sent();
                return [3, 6];
            case 4:
                err_1 = _c.sent();
                return [4, (0, effects_1.put)(actions_1.cmsWalkthroughScreensRequestAction.failure(err_1))];
            case 5:
                _c.sent();
                return [3, 6];
            case 6: return [2];
        }
    });
}
exports.getPortalWalkthroughScreens = getPortalWalkthroughScreens;
function getPortalWalkthrough(_a) {
    var config, client, data, err_2;
    var path = _a.payload.path;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 6]);
                return [4, (0, effects_1.select)(configuration_1.getApplicationConfiguration)];
            case 1:
                config = _b.sent();
                client = (0, get_cms_client_1.default)(even_cms_1.ItemsPortalWalkthroughsApi, config);
                return [4, (0, effects_1.apply)(client, client.readItemsPortalWalkthroughs, [undefined, undefined, undefined, undefined, undefined, undefined, path])];
            case 2:
                data = (_b.sent()).data.data;
                return [4, (0, effects_1.putResolve)(actions_1.cmsWalkthroughRequestAction.success((data === null || data === void 0 ? void 0 : data[0]) || {}))];
            case 3:
                _b.sent();
                return [3, 6];
            case 4:
                err_2 = _b.sent();
                return [4, (0, effects_1.put)(actions_1.cmsWalkthroughRequestAction.failure(err_2))];
            case 5:
                _b.sent();
                return [3, 6];
            case 6: return [2];
        }
    });
}
exports.getPortalWalkthrough = getPortalWalkthrough;
function portalWalkthroughSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, (0, effects_1.takeLatest)((0, typesafe_actions_1.getType)(actions_1.cmsWalkthroughRequestAction.request), getPortalWalkthrough)];
            case 1:
                _a.sent();
                return [4, (0, effects_1.takeLatest)((0, typesafe_actions_1.getType)(actions_1.cmsWalkthroughScreensRequestAction.request), getPortalWalkthroughScreens)];
            case 2:
                _a.sent();
                return [2];
        }
    });
}
exports.portalWalkthroughSaga = portalWalkthroughSaga;
